import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import {Bar} from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default function MonthChart({data, label}) {
  ChartJS.register(
    ChartDataLabels,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  )
  const options = {
    maintainAspectRatio: true,
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          precision: 0,
        },
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      datalabels: {display: false},
      legend: {
        display: false,
      },
    },
  }
  const dataChart = {
    datasets: [
      {
        borderWidth: 1,
        fill: true,
        data,
        label,
        backgroundColor: '#60a5fa',
        borderColor: '#0c4a6e',
      },
    ],
  }
  return <Bar data={dataChart} options={options} />
}
